import Form from "@/modules/signup/components/Form";

function Signup() {
  return <Form />;
}

export default Signup;
